import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetCallHistory,
  type IParamsGetCallHistoryStatistic,
  type IResponseCallHistory,
  type IResponseGetCallHistoryStatistic,
} from 'entities/CallHistory/api/types'

class Api {
  getCallHistoryStatistic(
    params: IParamsGetCallHistoryStatistic,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetCallHistoryStatistic>> {
    return baseApi.get('call-history/statistics', { params, ...options })
  }

  getCallHistory(
    params: IParamsGetCallHistory,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseCallHistory>> {
    return baseApi.get('call-history', { params, ...options })
  }
}

export const CallHistoryApi = new Api()
